export default {
  data() {
    return {
      //
      tableHeight: window.innerHeight - 250,
      // 遮罩层
      loading: true,
      // 选中数组
      multiBidSe: {},
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      currentPage: 1,
      limit: 200,
      // 表格数据
      sanBaoList: [],
      // 弹出层标题
      title: '',
      showError: false,
      errorTitle: '',
      // 是否显示弹出层
      open: false,
      open1: false,
      // 查询参数
      queryParams: {
        djh: undefined,
        jkr: undefined,
        lbmc: '全部',
        billcode: '未生成凭证'
      },
      // 表单参数
      form: {},
      statusOptions: [
        {
          dictLabel: '全部',
          dictValue: '全部'
        }, {
          dictLabel: '费用报销单',
          dictValue: '费用报销单'
        }, {
          dictLabel: '销售费用报销单',
          dictValue: '销售费用报销单'
        }, {
          dictLabel: '销售出差报销单',
          dictValue: '销售出差报销单'
        }
      ],
      statuspzh: [
        {
          dictLabel: '全部',
          dictValue: '全部'

        }, {
          dictLabel: '未生成凭证',
          dictValue: '未生成凭证'
        }, {
          dictLabel: '已生成凭证',
          dictValue: '已生成凭证'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {

    dateFormat(row, column) {
      const date = new Date(row.rq)
      let d = date.getFullYear() + '-'
      if ((date.getMonth() + 1) < 10) {
        d += '0' + (date.getMonth() + 1)
      } else {
        d += (date.getMonth() + 1)
      }
      d += '-'
      if (date.getDate() < 10) {
        d += '0' + date.getDate()
      } else {
        d += date.getDate()
      }
      return d
    },

    getList() {
      this.loading = true
      const data = {
        currentPage: this.currentPage,
        limit: this.limit,
        djh: this.queryParams.djh,
        jkr: this.queryParams.jkr,
        lbmc: this.queryParams.lbmc,
        ys_billcode: this.queryParams.billcode
      }
      this.$post('/fesback/Financial/sanBaoLists.z', data).then(request => {
        this.sanBaoList = request.data.data
        this.total = request.data.count
        this.loading = false
        this.$message({
          message: request.message,
          type: 'success'
        })
      })
    },

    handleQuery() {
      this.currentPage = 1
      this.getList()
    },
    tableSelection(selection, row) {
      this.$refs.bidSecurity.clearSelection()
      this.$refs.bidSecurity.toggleRowSelection(row)
      this.multiBidSe = row
    },
    tableRowClick(row) {
      this.$refs.bidSecurity.clearSelection()
      this.$refs.bidSecurity.toggleRowSelection(row)
      this.multiBidSe = row
    },
    tableSelectAll() {
      this.$refs.bidSecurity.clearSelection()
      this.multiBidSe = {}
    },
    // 生成凭证操作
    handlegGenerate(row) {
      if (Object.keys(this.multiBidSe).length === 0) {
        this.showError = true
        this.errorTitle = '请至少勾选一条单据信息'
        this.timeOUtHideError('showError')
        return false
      }
      this.showError = false
      const params = {
        djhs: this.multiBidSe.djh
      }
      this.$confirm('是否生成凭证?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        this.$post('/fesback/voucher/voucherAdd.z', params).then(request => {
          this.getList()
          this.$message({
            message: '生成凭证成功',
            type: 'success'
          })
        })
      })
    },
    timeOUtHideError(filed) {
      const _this = this
      setTimeout(function() {
        _this[filed] = false
      }, 3000)
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      this.queryParams.settleMode = undefined
      this.handleQuery()
    },
    handleSizeChange(val) { // 每页多少条
      this.limit = val
      this.getList()
    },
    handleCurrentChange(val) { // 当前页
      this.currentPage = val
      this.getList()
    }
  }
}
